// extracted by mini-css-extract-plugin
module.exports = {"formatted-date":"style_formatted-date__34V9G","icon":"style_icon__cuyZo","placeholder":"style_placeholder__3Yns-"};